import { render } from "./SystemNotificationModal.vue?vue&type=template&id=691973c0"
import script from "./SystemNotificationModal.vue?vue&type=script&lang=js"
export * from "./SystemNotificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__